/**
 * Agent knowledge service — ingest supporting material (pasted text, pasted HTML, a URL, or an uploaded
 * document) into an agent's knowledge base, list its sources + storage usage, remove one source, and
 * clear it. Storage is free within a per-agent byte cap. The agent retrieves this via RAG in the reply
 * path (when its knowledge_backend is set).
 */
import { callFunction } from '../utils/apiClient';

export interface KbSource { source: string; bytes: number; chunks: number; added_at: string }
export interface KbUsage { scopeId: string; bytes: number; cap: number; remaining: number; sources: KbSource[] }

export type IngestKind = 'text' | 'html' | 'url' | 'document';

/** Ingest text / HTML / a URL. For a document, use ingestAgentDocument. Returns updated usage. */
export const ingestAgentKnowledge = (agentKey: string, kind: IngestKind, content: string, source?: string) =>
  callFunction<{ usage: KbUsage }>('ingestAgentKnowledge', { agentKey, kind, content, source }).then((r) => r.usage);

/** Ingest an uploaded document (base64 content + mime). Returns updated usage. */
export const ingestAgentDocument = (agentKey: string, base64: string, mime: string, name: string) =>
  callFunction<{ usage: KbUsage }>('ingestAgentKnowledge', { agentKey, kind: 'document', content: base64, mime, source: name, name }).then((r) => r.usage);

export const listAgentKnowledge = (agentKey: string) =>
  callFunction<{ usage: KbUsage }>('listAgentKnowledge', { agentKey }).then((r) => r.usage);

export const removeAgentKnowledgeSource = (agentKey: string, source: string) =>
  callFunction<{ usage: KbUsage }>('removeAgentKnowledgeSource', { agentKey, source }).then((r) => r.usage);

export const clearAgentKnowledge = (agentKey: string) =>
  callFunction<{ usage: KbUsage }>('clearAgentKnowledge', { agentKey }).then((r) => r.usage);
